import React from 'react'
import SalePlanningTaskGrid from '../components/grids/SalePlanningTaskGrid'

const SalePlanningTasksPage = () => {
    return (
        <div id='sale-planning-tasks-grid' className='stretched row-based container'>
            <SalePlanningTaskGrid />
        </div>
    )
}

export default SalePlanningTasksPage
